import React, { useState } from "react";
import InputCustom from "./InputCustom";
import { handleAddUser } from "./UserService";
import Loading from "../../SubDashboard/Loading/Loading";
import { normalizePhone } from "./PhoneUtils";
import AvatarUpload from "../../Users/SubUsers/AvatarUpload";

function AddUser({ close, onUserAdded, openError, openSuccess }) {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        bio: "",
        urlWebHook: "https://sample.org/hook",
        tokenWebHook: "123456",
        webHookTokenHeader: "",
        ip: "",
        avatar: null
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [validationActive, setValidationActive] = useState(false);
    const [preview, setPreview] = useState(null);

    // ✅ انتخاب تصویر
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setForm((prev) => ({ ...prev, avatar: file }));
        setPreview(URL.createObjectURL(file));
    };

    const validateForm = () => {
        const newErrors = {};
        let finalPhone;

        if (!form.phone.trim()) {
            newErrors.phone = "شماره موبایل نمی‌تواند خالی باشد.";
        } else {
            try {
                finalPhone = normalizePhone(form.phone);
            } catch (err) {
                newErrors.phone = err.message;
            }
        }

        if (!form.urlWebHook.trim()) {
            newErrors.urlWebHook = "آدرس وب‌هوک نمی‌تواند خالی باشد.";
        }

        if (!form.tokenWebHook.trim()) {
            newErrors.tokenWebHook = "توکن وب‌هوک نمی‌تواند خالی باشد.";
        }

        setErrors(newErrors);

        return {
            isValid: Object.keys(newErrors).length === 0,
            finalPhone
        };
    };

    const handleChange = (field) => (value) => {
        setForm((prev) => ({ ...prev, [field]: value }));

        if (!validationActive) return;

        if (field === "phone") {
            try {
                normalizePhone(value);
                setErrors((prev) => ({ ...prev, phone: "" }));
            } catch (err) {
                setErrors((prev) => ({ ...prev, phone: err.message }));
            }
        }

        if (field === "urlWebHook") {
            setErrors((prev) => ({
                ...prev,
                urlWebHook: value.trim() ? "" : "آدرس وب‌هوک نمی‌تواند خالی باشد."
            }));
        }

        if (field === "tokenWebHook") {
            setErrors((prev) => ({
                ...prev,
                tokenWebHook: value.trim() ? "" : "توکن وب‌هوک نمی‌تواند خالی باشد."
            }));
        }
    };

    const handleClose = () => {
        setErrors({});
        setValidationActive(false);
        close(false);
    };

    const handleSubmit = async () => {
        setValidationActive(true);

        const { isValid, finalPhone } = validateForm();
        if (!isValid) return;

        setLoading(true);

        try {
            const data = await handleAddUser({
                ...form,
                phone: finalPhone
                // اگر خواستی avatar رو هم بفرستی اینجا هندل می‌کنیم
            });

            if (data.status === 200) {
                onUserAdded(data.data);
                openSuccess("کاربر مورد نظر با موفقیت ثبت شد.");
                handleClose();
            } else if (data.status === 409) {
                setErrors((prev) => ({
                    ...prev,
                    phone: "این شماره موبایل قبلاً ثبت شده است."
                }));
            } else {
                openError("ایجاد کاربر با خطا مواجه شد.");
            }
        } catch (err) {
            if (err.response && err.response.status === 409) {
                setErrors((prev) => ({
                    ...prev,
                    phone: "این شماره موبایل قبلاً ثبت شده است."
                }));
            } else {
                openError(err.message || "خطا در ایجاد کاربر.");
            }
        } finally {
            setLoading(false);
        }
    };

    const fields = [
        { title: "نام", field: "name" },
        { title: "شماره موبایل", field: "phone" },
        { title: "IP", field: "ip" },
        { title: "متن بیوگرافی", field: "bio" },
        { title: "webHookCallbackUrl", field: "urlWebHook" },
        { title: "webHookToken", field: "tokenWebHook" },
        { title: "TokenHeader", field: "webHookTokenHeader" }
    ];

    return (
        <>
            <div
                className="modal-overlay fixed top-0 left-0 w-screen h-screen bg-black opacity-40"
                onClick={handleClose}
            ></div>

            <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-primary-100 rounded-lg px-14 py-14">
                <div className="flex items-center justify-between mb-8">
                    <img
                        src="/image/icon/close.png"
                        className="w-5 cursor-pointer"
                        onClick={handleClose}
                    />
                    <p className="text-right text-lg font-bold text-slate-800">
                        ایجاد سازمان
                    </p>
                </div>

                <AvatarUpload
                    preview={preview}
                    onImageChange={handleImageChange}
                />

                {fields.map((f) => (
                    <div className="mb-4" key={f.field}>
                        <InputCustom
                            title={f.title}
                            value={form[f.field]}
                            onChange={handleChange(f.field)}
                            error={errors[f.field]}
                        />
                    </div>
                ))}

                <div className="flex flex-row-reverse justify-between mt-10 gap-4 flex-wrap">
                    <button
                        onClick={handleSubmit}
                        className="bg-primary-500 flex-1 rounded-lg text-white p-2"
                    >
                        ثبت
                    </button>
                    <button
                        onClick={handleClose}
                        className="border border-primary-500 flex-1 rounded-lg text-primary-500 p-2"
                    >
                        لغو
                    </button>
                </div>
            </div>

            {loading && <Loading />}
        </>
    );
}

export default AddUser;